<template>
  <!-- 消息通知列表，滚动显示 -->
  <div class="warn-list">
    <div class="title">
      <div class="left">
        <span>待办任务</span>
        <span class="bridge">{{ totalCount }}</span>
      </div>
      <table-button @click="toShowMore">查看更多</table-button>
    </div>
    <div
        class="content"
        ref="taskContent"
        @mouseenter="stopAutoScroll"
        @mouseleave="startAutoScroll"
        @wheel="handleWheel"
    >
      <!-- 数据>10条时使用transform滚动 -->
      <div
          class="scroll-wrapper"
          :style="{ transform: `translateY(${scrollOffset}px)`, transition: scrollTransition }"
      >
        <div v-for="(item, index) in originalTaskList" class="item" :key="'task-' + item.id + '-' + index">
          <div class="command-name">{{ item.projectName }}</div>
          <div class="command-desc">{{ item.templateName }} - {{item.userName}}</div>
          <div class="time">{{ item.taskTime? item.taskTime.substring(10, 19) : '' }}</div>
<!--          <table-button el-type="primary" @click="toExecute(item)">处理</table-button>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import TableButton from "@/components/h5/button/TableButton.vue";
import util from "@/util/util";
import safetyTaskRecordApi from "@/api/dz-luqiao/safetyTaskRecordsApi";

export default {
  props: {
    dataList: {
      // 使用{name: '', count: 0}
      default: () => []
    }
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "StaticBlock",
  components: {
    TableButton
  },
  data() {
    return {
      // 待办任务滚动相关
      scrollOffset: 0,
      totalCount: 0,
      // taskCount: 11,
      // 后期替换为后端接口数据即可
      originalTaskList: [

      ],
      scrollTransition: 'none',
      itemHeight: 0,
      containerHeight: 0,
    };
  },
  beforeUnmount() {
    this.stopAutoScroll();
  },
  created() {
  },
  mounted() {
    safetyTaskRecordApi.queryList({pageSize: 20}).then(res => {
      this.originalTaskList = res.records;
      this.totalCount = res.totalCount;
      this.$nextTick(() => {
        // 等待DOM渲染完成后，计算实际的任务项高度
        if (this.calculateItemHeight()) {
          this.updateScrollMode();
        }
      });
    })




    // commonApi.queryWarnList({warnTypes: "XJ_WARN", status: 1}).then(res => {
    //   this.originalTaskList = res.records;
    //   this.totalCount = res.totalCount;
    //   this.$nextTick(() => {
    //     // 等待DOM渲染完成后，计算实际的任务项高度
    //     if (this.calculateItemHeight()) {
    //       this.updateScrollMode();
    //     }
    //   });
    // })

  },
  methods: {
    // 执行任务
    toExecute(data) {
      // 巡检任务
      this.router.push(`/sys/warning/detail?type=view&id=${data.id}`);
    },
    toShowMore() {
      // 由于不是router页面，无法触发beforeRouteLeave，手动调用
      let to = { path: `/checkWarranty/plan/record`, fullPath: `/checkWarranty/plan/record` };
      util.cachePageData(null, to, {path: "/welcome", fullPath: "/welcome"});
      this.router.push(`/checkWarranty/plan/record`);
    },
    // 任务总数
    taskCount() {
      return this.originalTaskList.length;
    },
    // 计算单个任务项的实际高度
    calculateItemHeight() {
      const contentEl = this.$refs.taskContent;
      // 容器高度
      this.containerHeight = contentEl.offsetHeight;
      console.log('容器高度：', this.containerHeight)
      if (contentEl && contentEl.querySelector('.item')) {
        const firstItem = contentEl.querySelector('.item');
        const style = window.getComputedStyle(firstItem);
        const marginTop = parseFloat(style.marginTop);
        this.itemHeight = firstItem.offsetHeight + marginTop;
        console.log('任务项高度：', this.itemHeight)
      }
      console.log("总高度：" + this.itemHeight * this.taskCount())
      // 如果总高度大于容器，则启动自动滚动
      return this.itemHeight * this.taskCount() > this.containerHeight;
    },
    // 更新滚动模式
    updateScrollMode() {
      const contentEl = this.$refs.taskContent;
      if (this.taskCount() <= 10) {
        // 数据≤10条：显示滚动条，停止自动滚动
        if (contentEl) {
          contentEl.style.overflowY = 'auto';
        }
        this.stopAutoScroll();
        this.scrollOffset = 0;
      } else {
        // 数据>10条：隐藏滚动条，启动自动滚动
        if (contentEl) {
          contentEl.style.overflowY = 'hidden';
        }
        this.startAutoScroll();
      }
    },
    // 停止自动滚动
    stopAutoScroll() {
      this.isAutoScrolling = false;
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
        this.scrollTimer = null;
      }
    },
    // 处理鼠标滚轮事件
    handleWheel(event) {
      // 数据少于等于10条时，允许默认滚动行为
      if (this.taskCount() <= 10) {
        return; // 不阻止默认行为，让浏览器正常滚动
      }

      // 数据>10条时，使用自定义滚动
      event.preventDefault(); // 阻止默认滚动

      // 暂停自动滚动
      this.stopAutoScroll();

      // 根据滚轮方向调整滚动位置
      const delta = event.deltaY;
      this.scrollOffset -= delta * 0.5; // 调整滚动速度

      // 使用动态的数据长度限制滚动范围
      const halfListHeight = this.itemHeight * this.taskCount();
      const maxScroll = 0;
      const minScroll = -halfListHeight;

      if (this.scrollOffset > maxScroll) {
        this.scrollOffset = minScroll + (this.scrollOffset - maxScroll);
      } else if (this.scrollOffset < minScroll) {
        this.scrollOffset = maxScroll + (this.scrollOffset - minScroll);
      }

      // 滚轮停止后，延迟恢复自动滚动
      clearTimeout(this.wheelTimeout);
      this.wheelTimeout = setTimeout(() => {
        this.startAutoScroll();
      }, 2000); // 2秒后恢复自动滚动
    },
    // 开始自动滚动
    startAutoScroll() {
      this.isAutoScrolling = true;
      if (this.scrollTimer) return;

      // 只有当数据大于10条时才启动滚动
      if (this.taskCount() <= 10) {
        return;
      }

      this.scrollTimer = setInterval(() => {
        if (!this.isAutoScrolling) return;

        // 每次向上滚动0.5px，更流畅
        this.scrollOffset -= 0.5;

        // 使用动态的数据长度计算
        const halfListHeight = this.itemHeight * this.taskCount();

        // 当滚动到一半时，无缝重置位置
        if (Math.abs(this.scrollOffset) >= halfListHeight - this.containerHeight) {
          console.log('重置位置');
          console.log(this.scrollOffset)
          // 临时禁用transition，实现瞬间重置
          this.scrollTransition = 'none';
          this.scrollOffset = 0;

          // 下一帧恢复transition
          this.$nextTick(() => {
            this.scrollTransition = 'none'; // 保持无transition，让滚动更流畅
          });
        }
      }, 20); // 20ms滚动一次
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../components/h5/board/common";
.warn-list{
  height: 100%;
}
.content{
  flex: 1;
  margin-top: 16px;
  position: relative;
  cursor: pointer;
  height: calc(100% - 30px);

  /* 动态控制overflow，由JS控制 */
  overflow-y: auto;

  /* 当数据>10条时，通过JS设置overflow:hidden，此时滚动条样式无效 */
  /* 当数据≤10条时，显示美化的滚动条 */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }

  .scroll-wrapper {
    will-change: transform;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
  }

  .normal-wrapper {
    // 普通模式下不需要特殊样式
  }

  .scroll-wrapper,
  .normal-wrapper {
    .item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px;
      margin-top: 8px;
      border-radius: 8px;
      background: #fafafa;
      transition: var(--transition);

      &:first-child{
        margin-top: 0;
      }

      &:hover{
        background: #f0f9ff;
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.15);
      }

      .idx{
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: #FFF;
        border-radius: 50%;
        font-size: 12px;
        font-weight: 600;
        flex-shrink: 0;
      }

      .command-name{
        width: 80px;
        font-size: 13px;
        font-weight: 600;
        color: #303133;
        flex-shrink: 0;
      }

      .command-desc{
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #606266;
        font-size: 13px;
        margin: 0 12px;
      }

      .time{
        width: 60px;
        color: #909399;
        font-size: 12px;
        flex-shrink: 0;
      }
    }
  }
}
</style>